import type { PropsWithChildren } from 'react';
import { ErrorBoundary, type ErrorBoundaryProps } from 'react-error-boundary';

import { logError } from '@/shared/lib/logging';

import { ErrorFallback } from './error-fallback/error-fallback';

interface ErrorBoundaryProviderProps extends PropsWithChildren {}

const errorHandler = (
    ...args: Parameters<NonNullable<ErrorBoundaryProps['onError']>>
) => {
    const [error, info] = args;

    logError(
        `[ERROR NAME]: ${error.name}\n[ERROR MESSAGE]: ${error.message}\n[ERROR INFO]: ${info.componentStack}`,
    );
};

export function ErrorBoundaryProvider(props: ErrorBoundaryProviderProps) {
    const { children } = props;

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={errorHandler}
        >
            {children}
        </ErrorBoundary>
    );
}
